import React, { useEffect } from "react";
import {
  AutoComplete,
  Box,
  Cell,
  CustomModalLayout,
  Divider,
  Heading,
  Layout,
  Modal,
  Pagination,
  Table,
  Text,
  Tooltip,
} from "@wix/design-system";
import picture from "../../../dashboard/images/no-image.png";
import WixLogo from "../../../dashboard/pages/wix_logo.svg";
import { removeDuplicates, truncateText } from "../../../services/utils/productUtils";
import Loading from "../Loader";
import WixCollection from "../../../models/wix-collection";

const ExportCategoryModal = (props: any) => {
  // get Viewport width
  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  // Calculate 60% of the viewport widthz
  let boxWidth = Math.floor(0.6 * viewportWidth);
  /*
  |--------------------------------------------------------------------------
  | States
  |--------------------------------------------------------------------------
  |
  */
  const [collections, setCollections] = React.useState([]);
  const [totalPage, setTotalPage] = React.useState(1);
  const [currentPage, setCurrentPage] = React.useState();
  const [isLoading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  /*
  |--------------------------------------------------------------------------
  | Handle Page Change
  |--------------------------------------------------------------------------
  |
  */
  const pageChangeHandler = (event: any) => {
    setCurrentPage(event.page);
  };
  /*
  |--------------------------------------------------------------------------
  | Handle Selected Products
  |--------------------------------------------------------------------------
  |
  */
  const handleSelectedProducts = () => {
    let selectedCollections = removeDuplicates(props.selectedCollections);
    const parameters = {
      perPage: 4,
      page: currentPage,
    };
    let params = {};
    if (props.source === "wix") {
      params = {
        collectionIds: selectedCollections.toString(),
      };
    }
    const allParameters = {
      ...parameters,
      ...params,
    };
    setLoading(true);
    if (props.source === "wix") {
      WixCollection.get(allParameters)
        .then((response) => {
          setCollections(response.data.data);
          const total = response.data.last_page;
          setTotalPage(total);
        })
        .catch((error) => console.error(error))
        .finally(() => {
          setLoading(false);
        });
    }
  };
  /*
  |--------------------------------------------------------------------------
  | Check If Category Selected
  |--------------------------------------------------------------------------
  |
  */
  const checkCategorySelected = (event: any) => {
    event.preventDefault();
    if (props.source === "wix") {
      if (props.categoryId !== "0") {
        props.handleExport(props.categoryId);
        return setError(false);
      }
      return setError(true);
    } else {
      return props.handleExport();
    }
  };
  useEffect(() => {
    if (props.showExportConfirmation === true) {
      handleSelectedProducts();
    }
  }, [props.showExportConfirmation, currentPage]);

  /*
  |--------------------------------------------------------------------------
  | Table Columns
  |--------------------------------------------------------------------------
  |
  */
  const columns: any = [
    {
      title: "",
      width: "5%",
      render: (row: any) => (
        <Layout>
          <Cell span={3}>
            <Box width="40px" height="45px" overflow="hidden">
              <img src={row.thumbnail ? row.thumbnail : picture} />
            </Box>
          </Cell>
        </Layout>
      ),
    },
    {
      title: "Category",
      width: "52%",
      render: (row: any) => (
        <Layout>
          <Cell span={9}>
            <Tooltip content={row.name}>
              <Text
                style={{
                  fontSize: "14px ",
                  lineHeight: "18px",
                }}
                weight="bold"
              >
                {truncateText(row.name, 30)}
              </Text>
            </Tooltip>
          </Cell>
        </Layout>
      ),
    },
    {
      title: "Products",
      width: "10%",
      render: (row: any) => <>{row.no_of_products + " Products"}</>,
    },
    {
      title: "View on",
      width: "10%",
      render: (row: any) => (
        <>
          <Layout>
            <Cell span={4}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Tooltip appendTo="window" content="View this product on Wix dashboard">
                  <a href={row.details_url} target="_blank">
                    <img width="32px" height="12px" src={WixLogo} />
                  </a>
                </Tooltip>
              </div>
            </Cell>
          </Layout>
        </>
      ),
    },
  ];
  return (
    <Modal
      isOpen={props.showExportConfirmation}
      onRequestClose={() => props.setShowExportConfirmation(false)}
      shouldCloseOnOverlayClick
      screen="desktop"
      onAfterClose={props?.onAfterClose}
    >
      <CustomModalLayout
        removeContentPadding
        primaryButtonText="Export"
        primaryButtonOnClick={(event: any) => {
          checkCategorySelected(event);
        }}
        onCloseButtonClick={() => {
          props.setShowExportConfirmation(false);
          props.setCategoryId("0");
        }}
        secondaryButtonText="Cancel"
        secondaryButtonOnClick={() => {
          props.setShowExportConfirmation(false);
          props.setCategoryId("0");
        }}
        title={
          <Box style={{ justifyContent: "space-between" }}>
            <Heading size="large">{props?.title}</Heading>
            {props.source === "wix" && (
              <Box direction="vertical">
                <AutoComplete
                  id="export_DropdownId"
                  size="small"
                  border="round"
                  options={props?.options}
                  onSelect={props?.onSelect}
                  selectedId={props.categoryId}
                  placeholder={props.placeholder}
                  infiniteScroll
                  hasMore={props.hasMore}
                  loadMore={props?.loadMore}
                  onChange={props?.onChange}
                  value={props?.value}
                />
                <Text skin="error" size="small">
                  {error && "*Category is required."}
                </Text>
              </Box>
            )}
          </Box>
        }
        subtitle={props?.subtitle}
        content={
          <Box align="center" maxHeight={"390px"} minHeight={"100px"} width={`${boxWidth}px`}>
            <Layout justifyItems="center">
              <Cell>
                <Table data={collections} columns={columns} rowVerticalPadding="tiny">
                  {isLoading ? (
                    <Loading title="Fetching Selected Products" />
                  ) : (
                    <Table.Content titleBarVisible={true} />
                  )}
                </Table>
                <Divider />
              </Cell>
              <Cell>
                <Pagination currentPage={currentPage} onChange={pageChangeHandler} totalPages={totalPage} />
              </Cell>
            </Layout>
          </Box>
        }
      />
    </Modal>
  );
};
export default ExportCategoryModal;
